<script setup></script>

<template>
  <div class="flex flex-col items-start gap-x-16 md:flex-row md:gap-8">
    <div class="bg-cerulean flex-none p-4">
      <NuxtImg
        src="/artist/kate-self-portrait.png"
        width="351"
        height="381"
        dimensions="x1 x2"
        format="webp"
        alt="A photo of the artist - a redhead with rainbow glasses against a blue and gold background"
      />
    </div>

    <div>
      <div class="pt-8 md:pt-1">
        <h2 class="pb-2 text-2xl">Kate Nahodyl is a fine artist & sculpting instructor in Atlanta, Georgia.</h2>

        <div class="bg-yellow h-1" />
      </div>

      <div class="py-8 text-center">
        <blockquote class="font-script text-lg">
          "Of all the paths you take in life, make sure a few of them are dirt."
        </blockquote>
        <p class="pt-4 text-xs">- John Muir</p>
      </div>

      <div class="space-y-5 py-10 text-xl">
        <p>
          Kate discovered ceramics during an especially tough personal journey and found healing in the tactile,
          malleable, and meditative process that comes from working with clay. Her sculptures represent her experience
          with womanhood. Her signature ‘heart eyes’ ups the cute factor in her pieces, but the overall effect is
          achieved in her ability to create complex, anthropomorphic personalities in her creatures.
        </p>

        <p>
          Kate’s background in geology - BS in Environmental Geology from Georgia State University & from years working
          as a field geologist in the geotechnical engineering industry - helps with understanding the chemical
          processes that her work undergoes through each phase of the ceramic process.
        </p>

        <p>
          Her body of work includes ceramic sculptures, functional ceramic pieces, fine art, digital art, signage,
          murals, and terrible jokes.
        </p>

        <p>
          You can usually find Kate, covered in clay, working from her home studio or at The Art Center, where she
          teaches.
        </p>
      </div>
    </div>
  </div>
</template>
